import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
}, React.createElement("path", {
  d: "M961 1C431.645 1 1 431.645 1 961s430.645 960 960 960 960-430.645 960-960S1490.355 1 961 1m0 1807.059c-467.125 0-847.059-379.934-847.059-847.059 0-467.125 379.934-847.059 847.059-847.059 467.125 0 847.059 379.934 847.059 847.059 0 467.125-379.934 847.059-847.059 847.059m319.465-1246.374l-319.51 319.51-319.398-319.51-79.85 79.85 319.398 319.51-319.397 319.398 79.85 79.85 319.397-319.398 319.51 319.397 79.85-79.85-319.51-319.397 319.51-319.51-79.85-79.85z"
}));

var IconTroubleLine =
/*#__PURE__*/
function (_Component) {
  _inherits(IconTroubleLine, _Component);

  function IconTroubleLine() {
    _classCallCheck(this, IconTroubleLine);

    return _possibleConstructorReturn(this, _getPrototypeOf(IconTroubleLine).apply(this, arguments));
  }

  _createClass(IconTroubleLine, [{
    key: "render",
    value: function render() {
      return React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconTrouble",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconTroubleLine.displayName = "IconTroubleLine";
  return IconTroubleLine;
}(Component);

IconTroubleLine.glyphName = 'trouble';
IconTroubleLine.variant = 'Line';
IconTroubleLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconTroubleLine;
export { IconTroubleLine };